const pad = (value) => String(value).padStart(2, "0");

const montarDataIso = (ano, mes, dia) => {
  const anoNum = Number(ano);
  const mesNum = Number(mes);
  const diaNum = Number(dia);

  if (!Number.isInteger(anoNum) || !Number.isInteger(mesNum) || !Number.isInteger(diaNum)) {
    return "";
  }

  if (anoNum <= 0 || mesNum < 1 || mesNum > 12 || diaNum < 1 || diaNum > 31) {
    return "";
  }

  const data = new Date(Date.UTC(anoNum, mesNum - 1, diaNum));
  if (
    Number.isNaN(data.getTime()) ||
    data.getUTCFullYear() !== anoNum ||
    data.getUTCMonth() !== mesNum - 1 ||
    data.getUTCDate() !== diaNum
  ) {
    return "";
  }

  return `${String(anoNum).padStart(4, "0")}-${pad(mesNum)}-${pad(diaNum)}`;
};

export const normalizarDataEntrada = (valor) => {
  if (!valor) return "";

  if (typeof valor === "string") {
    const valorLimpo = valor.trim();

    const matchIso = valorLimpo.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (matchIso) {
      return montarDataIso(matchIso[1], matchIso[2], matchIso[3]);
    }

    const matchBr = valorLimpo.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (matchBr) {
      return montarDataIso(matchBr[3], matchBr[2], matchBr[1]);
    }
  }

  const data = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(data.getTime())) {
    return "";
  }

  return montarDataIso(data.getFullYear(), data.getMonth() + 1, data.getDate());
};

export const formatarDataParaExibicao = (valor) => {
  const dataNormalizada = normalizarDataEntrada(valor);
  if (!dataNormalizada) return "";

  const [ano, mes, dia] = dataNormalizada.split("-");
  return `${dia}/${mes}/${ano}`;
};
